<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="box">
        <div class="box-header b-b">
          <h5>Transaction Report</h5>
          <small>Shows cumulative transaction by date</small>
        </div>
        <div class="box-tool">
          <ul class="nav">
            <li class="nav-item inline dropdown">
              <a 
                data-toggle="dropdown" 
                class="btn btn-default">Export</a>
              <div class="dropdown-menu dropdown-menu-scale pull-right">
                <span class="dropdown-header">Export As</span>
                <a 
                  class="dropdown-item" 
                  @click.prevent="exportAsFile('CSV')">CSV</a>
                <a 
                  class="dropdown-item" 
                  @click.prevent="exportAsFile('XLSX')">XLSX</a>
                <a 
                  class="dropdown-item" 
                  @click.prevent="exportAsFile('PDF')">PDF</a>
              </div>
            </li>
          </ul>
        </div>
        <div class="box-body">
          <chart 
            ref="chart" 
            :options="line"/>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.echarts {
    height: 300px;
    width: 100%;
}
</style>

<script>
import { mapGetters } from 'vuex';
import Currency from '@js/plugins/currency';

export default {
    props: {
        Currency: {
            type: String,
            default: 'RM',
        },
    },

    data: function() {
        return {
            total_receipts: [],
            list: '',
            line: {
                title: {
                    text: '',
                },
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    data: [
                        {
                            name: 'Total Sales (' + this.Currency + ')',
                            icon: 'circle',
                        },
                        {
                            name: 'Total Transaction',
                            icon: 'circle',
                        },
                    ],
                },
                grid: {
                    x: 50,
                    x2: 50,
                },
                xAxis: {
                    data: [],
                    type: 'category',
                    animation: true,
                    boundaryGap: false,
                },
                yAxis: [
                    {
                        name: 'Total Sales (' + this.Currency + ')',
                        type: 'value',
                    },
                    {
                        name: 'Total Transaction',
                        type: 'value',
                    },
                ],
                series: [
                    {
                        name: 'Total Sales (' + this.Currency + ')',
                        type: 'line',
                        data: [],
                        smooth: true,
                        animation: true,
                        symbolSize: 10,
                        itemStyle: {
                            normal: {
                                color: '#0cc2aa',
                            },
                        },
                    },
                    {
                        name: 'Total Transaction',
                        yAxisIndex: 1,
                        type: 'line',
                        data: [],
                        smooth: true,
                        symbolSize: 10,
                        animation: true,
                        itemStyle: {
                            normal: {
                                color: '#C70039',
                            },
                        },
                    },
                ],
            },
        };
    },

    computed: {
        ...mapGetters(['dateFilter']),

        api() {
            return Laroute.route(
                'franchise.report.transaction.graphTransaction',
                { id: this.outlet },
            );
        },

        outlet() {
            return this.$store.getters.activeOutlet;
        },

        franchiseCurrency() {
            return Currency.hasCurrency();
        },
    },

    watch: {
        outlet() {
            this.getGraphData();
        },

        dateFilter(a, b) {
            if (a == b) return;
            this.getGraphData();
        },

        '$store.getters.currency': {
            immediate: true,
            handler() {
                const currency =
                    this.$store.getters.currency == null
                        ? this.franchiseCurrency
                        : this.$store.getters.currency;
                this.line.legend.data[0].name = `Total Sales (${currency})`;

                this.line.yAxis[0].name = `Total Sales (${currency})`;

                this.line.series[0].name = `Total Sales (${currency})`;
            },
        },
    },

    mounted: function() {
        this.getGraphData();
        var that = this;
        window.onresize = function() {
            that.$refs.chart.resize();
        };
    },

    methods: {
        exportAsFile(type) {
            let url = Laroute.route(
                'franchise.report.transaction.export_graph',
                { type: type },
            );
            let options = {
                outlet_id: this.outlet,
                since: this.$store.getters.startDate.format(),
                until: this.$store.getters.endDate.format(),
            };

            window.open(url + '?' + $.param(options));
        },

        getGraphData: function() {
            this.loading = true;
            var chart = this.$refs.chart;
            chart.showLoading({
                text: 'loading...',
            });

            let options = {
                since: this.$store.getters.startDate.format(),
                until: this.$store.getters.endDate.format(),
            };

            this.$http.get(this.api, { params: options }).then(response => {
                let data = response.data.data;
                let hourly = response.data.hourly;

                if (data) {
                    chart.hideLoading();

                    if (hourly) {
                        this.line.xAxis.data = data.map(obj =>
                            moment(obj.settled_date_receipt).format('hh:mm A'),
                        );
                    } else {
                        this.line.xAxis.data = data.map(obj =>
                            moment(obj.settled_date_receipt).format(
                                'ddd - DD/MM/YYYY',
                            ),
                        );
                    }

                    this.line.series[0].data = data.map(
                        obj => obj.total_receipt_payment,
                    );
                    this.line.series[1].data = data.map(
                        obj => obj.total_receipt,
                    );
                }
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/transaction/chart.vue